import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/eye-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M634 471c3.3 2.7 6 8.3 6 12.5 0 3.1-1.6 7.6-3.5 10l-10 12.5c-2.7 3.3-8.2 6-12.5 6-3.1 0-7.6-1.6-10-3.5l-598-467.5c-3.3-2.7-6-8.3-6-12.5 0-3.1 1.6-7.6 3.5-10l10-12.5c2.7-3.3 8.2-6 12.5-6 3.1 0 7.6 1.6 10 3.5zM296.8 146.5c6.3-1.4 16.7-2.5 23.2-2.5 60.5 0 109.4 47.9 111.6 107.8zM343.2 365.5c-6.3 1.3-16.7 2.4-23.2 2.5-60.5 0-109.3-47.9-111.6-107.8zM320 112c-19.9 0-39.3 2.8-58.2 7.1l-46.4-36.3c32.9-11.8 67.9-18.8 104.6-18.8 122.9 0 230.3 71.6 284.6 177.4 1.9 3.8 3.5 10.3 3.5 14.6s-1.6 10.8-3.5 14.6c-11.7 22.8-35.4 56.4-52.9 75.1l-37.7-29.5c14.3-15 34-42 44-60.2-48.8-89-139.3-144-237.9-144zM320 400c19.9 0 39.3-2.8 58.2-7.1l46.4 36.3c-32.9 11.8-67.9 18.8-104.6 18.8-122.9 0-230.3-71.6-284.5-177.4-1.9-3.8-3.5-10.3-3.5-14.6s1.6-10.8 3.5-14.6c11.7-22.8 35.4-56.4 52.9-75.1l37.7 29.5c-14.3 15-34.1 42-44 60.2 48.8 89 139.3 144 237.9 144z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/eye-slash.js
// module id = 1728
// module chunks = 0